export default class SpriteSheet {

  constructor(pcontent, ptotalFrames, pFramesPerSecond, pWidth, pHeight, imagePath, pOnComp){  
    this.CONTENT = null;
    this.TOTAL_FRAMES = 0;
    this.INTERVAL = 0;
    this.WIDTH = 0;
    this.HEIGHT = 0;
    this.IMAGE = "";
    this.INFINITE = true;
    this.onComplete;

    this.hasToAnim = true;
    this.isReverse = false;
    this.currentFrame = 0;
  }

  build(pcontent, ptotalFrames, pFramesPerSecond, imagePath, pInfinite, pOnComp){

    this.CONTENT = pcontent;        
    this.TOTAL_FRAMES = ptotalFrames;
    this.INTERVAL = 1000 / pFramesPerSecond;
    // this.WIDTH = pWidth;
    // this.HEIGHT = pHeight;
    this.IMAGE = imagePath;
    this.INFINITE = typeof pInfinite === 'undefined' ? true : pInfinite;
    this.onComplete = pOnComp;

    this.CONTENT.css("background-image", "url('"+ this.IMAGE +"')");

    this.resizeFix();

    return this;
  }

  resizeFix() {
    let elWidth = this.CONTENT.width();
    
    let img = new Image();
    img.src = this.IMAGE;
    img.onload = () => {
      let imgWidth = img.naturalWidth;
      let imgHeight = img.naturalHeight;
      
      let wRatio = elWidth / imgWidth;
      
      let newWidth = imgWidth * wRatio;
      let newHeight = imgHeight * wRatio;
      
      this.WIDTH = newWidth;
      this.HEIGHT = newHeight / this.TOTAL_FRAMES;
      // console.log('resizeFix ', wRatio, newWidth, newHeight);
      this.CONTENT.css('background-size', newWidth + 'px ' + newHeight + 'px');
    };
  }

  start(isRev){
    this.isReverse = isRev || false;

    this.hasToAnim = true;
    this.loop();
    return this;
  }

  stop(){
    this.hasToAnim = false;

    // currentFrame = 0;
    this.loop();
  }

  loop(){
    const _self = this;

    let posy = -(this.HEIGHT * this.currentFrame) + "px";
    // console.log('posy: ', this.HEIGHT, this.currentFrame);

    const val = 'center '+ posy;

    this.CONTENT.css({
      'backgroundPosition': val
    });


    if((this.hasToAnim == true) && ((this.currentFrame < this.TOTAL_FRAMES - 1 && this.isReverse == false) || (this.currentFrame > 0 && this.isReverse == true)))
    {
      if(this.isReverse == true)
        this.currentFrame--;
      else
        this.currentFrame++;

      setTimeout(_self.loop.bind(_self), _self.INTERVAL);
    }
    else
    {
      if(this.currentFrame == this.TOTAL_FRAMES - 1)
      {
        if(this.INFINITE) {
          this.currentFrame = 0;
          setTimeout(_self.loop.bind(_self), _self.INTERVAL);
        }
        if(typeof this.onComplete === 'function'){
          this.onComplete();
        }                
      }
    }
  }
}